import { ExtraJobStatus } from '../../utility-handler/utilities/jobs/extra';
import { IAmount } from '../money/IAmount';

export interface IJob {
    id: number;
    name: string;
    prices: {
        base: IAmount;
        floor: IAmount;
    };
    order: number;
    category: IJobCategory;
}

export interface IJobCategory {
    id: number;
    name: string;
    order: number;
    has_languages: boolean;
    has_softwares: boolean;
    group: IJobGroup;
}

export interface IJobGroup {
    id: number;
    name: string;
    order: number;
}

export interface IExtraJob {
    id: number;
    catId: number;
    catName: string;
    expId: number;
    expName: string;
    jobId: number;
    jobName: string;
    jobPrice: IAmount;
    verifiedByAdmin: boolean;
}

export interface IExtraJobWithQuiz extends IExtraJob {
    status?: ExtraJobStatus;
    quizNextAvailableTryAt?: string;
}

export interface IProJobsResponse {
    favoriteJobs: IJob[];
    jobs: IJob[];
    categories: IJobCategory[];
}

export interface IProJobsResponseFromApi {
    favoriteJobs: IJob[];
    jobs: IJob[];
}

export const MINIMUM_PRICE_HOUR = 12;
